import { render, staticRenderFns } from "./ViewLogout.vue?vue&type=template&id=3b24cdba&scoped=true"
import script from "./ViewLogout.vue?vue&type=script&lang=js"
export * from "./ViewLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b24cdba",
  null
  
)

export default component.exports